// extracted by mini-css-extract-plugin
export default {"thirdPartyLoginButton":"thirdPartyLoginButton__hD89fISK","thirdPartyLoginButtonText":"thirdPartyLoginButtonText__KOibHxfW"};